import { useState } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonText, IonIcon } from '@ionic/react';
import { close } from 'ionicons/icons';
import './FlightPriceDetails.css';
import { TranslateAgeCode } from '../../../defines/Functions';
import CurrencyFormat from 'react-currency-format';

interface Props {
    data: any
}
const FlightPriceDetails = (item: Props) => {
    const [showFlightPriceDetailsModal, setShowFlightPriceDetailsModal] = useState(false);
    return (
        <>
            <IonModal isOpen={showFlightPriceDetailsModal} onDidDismiss={() => setShowFlightPriceDetailsModal(false)} mode="ios" cssClass="flight-price-details-modal">
                <div>
                    <h3 className="flight-price-details-modal-title">
                        جزئیات قیمتی پرواز
                        <IonIcon icon={close} onClick={() => setShowFlightPriceDetailsModal(false)} />
                    </h3>
                    {item.data.airItineraryPricingInfo.ptcfareBreakdowns.ptcfareBreakdown.map((ptc: any, index: number) =>
                        <div className="flight-price-details-modal-items" key={'index' + index}>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size="6">
                                        <span>نوع مسافر: </span>
                                        <b>{TranslateAgeCode(ptc.passengerTypeQuantity.code)} ({ptc.passengerTypeQuantity.quantity} نفر)</b>
                                    </IonCol>
                                    <IonCol size="6">
                                        <span>قیمت پایه (هر نفر): </span>
                                        <b>
                                            <CurrencyFormat value={ptc.passengerFare[0].baseFare.amount} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                        </b>
                                    </IonCol>
                                    <IonCol size="6">
                                        <span>مالیات و اضافه بها (هر نفر): </span>
                                        <b>
                                            <CurrencyFormat value={ptc.passengerFare[0].totalFare.amount - ptc.passengerFare[0].baseFare.amount} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                        </b>
                                    </IonCol>
                                    <IonCol size="6">
                                        <span>مجموع (هر نفر): </span>
                                        <b>
                                            {item.data.discountPercentage ?
                                                <>
                                                    {ptc.passengerFare[0].totalFare.amount > (ptc.passengerFare[0].totalFare.amount - (ptc.passengerFare[0].totalFare.amount * item.data.discountPercentage / 100)) &&
                                                        <del>
                                                            <CurrencyFormat value={ptc.passengerFare[0].totalFare.amount} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                                        </del>
                                                    }
                                                    <CurrencyFormat value={Math.floor(ptc.passengerFare[0].totalFare.amount - (ptc.passengerFare[0].totalFare.amount * item.data.discountPercentage / 100))} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                                </>
                                                :
                                                <CurrencyFormat value={ptc.passengerFare[0].totalFare.amount} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                            }
                                        </b>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </div>
                    )}
                </div>
                <IonButton color="warning" onClick={() => setShowFlightPriceDetailsModal(false)} className="flight-price-details-modal-close-btn">بستن</IonButton>
            </IonModal>
            <IonText className="flight-price-details-label" onClick={() => setShowFlightPriceDetailsModal(true)}>جزئیات قیمت</IonText>
        </>
    );
};
export default FlightPriceDetails;